const TYPES = {
  EMAIL: 'email',
  PHONE: 'telPortable',
  CARD: 'numeroCarte',
  LASTNAME: 'nom',
  FIRSTNAME: 'prenom',
  BIRTHDATE: 'dateNaissance',
};


export const init = (select, questions, answer, locale, value) => {
  questions.forEach(question => {
    const { fiedlHasValue: fieldHasValue, fieldName } = question;

    return fieldHasValue && addOption(select, fieldName);
  });

  select.on('change', () => updateAnswerInput(select, answer, locale, value));
};

const addOption = (select, fieldname) => {
  const option = document.createElement('option');
  option.value = fieldname;

  switch (fieldname) {
    case TYPES.EMAIL:
      option.text = window.Messages('createAccount.whatIsYourEmail');
      break;

    case TYPES.PHONE:
      option.text = window.Messages('createAccount.whatIsYourPhoneNumber');
      break;

    case TYPES.CARD:
      option.text = window.Messages('createAccount.whatIsYourLoyaltyCard');
      break;

    case TYPES.LASTNAME:
      option.text = window.Messages('createAccount.whatIsYourLastName');
      break;

    case TYPES.FIRSTNAME:
      option.text = window.Messages('createAccount.whatIsYourFirstName');
      break;

    case TYPES.BIRTHDATE:
      option.text = window.Messages('createAccount.whatIsYourBirthdate');
      break;

    default:
  }

  select.appendChild(option);
  $(select).selectpicker('refresh');
};

const updateAnswerInput = (select, answer, locale, format) => {
  const { value } = select;
  const { classList } = answer.closest('.form-group');

  answer.value = '';
  classList.remove('validated', 'has-error');

  if (value === TYPES.BIRTHDATE)
    $(answer)
      .datetimepicker({
        locale,
        format
      })
      .data('DateTimePicker')
      .maxDate(new Date());
  else if ($(answer).data('DateTimePicker'))
    $(answer)
      .data('DateTimePicker')
      .destroy();
};


// WEBPACK FOOTER //
// ./src/customer/authentication/authentication-secret-question.js